module.exports = __webpack_public_path__ + "static/img/5-active.46f4cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/5-active.png
// module id = SmPT
// module chunks = 1